export const collections = {
  templates: 'templates',
  albums: 'albums',
  albumConfigurations: 'album-configurations',
  coverTemplates: 'cover-templates',
  useFirestoreForProfile: true,
};
